import React from 'react';
import { hitZoneCalc } from '../../utils/hitZoneCalc';
import HitCourseModal from '../video/HitCourseModal';
import { chooseColorCode } from '../../utils/color/commonColor';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

function HitCourseZoneChart({data, ballCodeArr, hitResultObj, colorType, checkObj, hitCheckObj}) {
    let filterData = _.filter(data, (item, idx) => {
        let condi = false;
        if(checkObj[item['ballCode']] && hitCheckObj[item['hitResultCode']]) {
            condi = true;
        }

        return condi;
    });

    let calcData = hitZoneCalc(250, filterData);

    const { t } = useTranslation();

    function ballCodeColorHandler(ballCode) {
        let ballCodeObj = _.find(ballCodeArr, (item) => (item['code'] === ballCode));

        if(ballCodeObj) {
            return ballCodeObj['color'];
        } else {
            return '#ffffff';
        }
    }

    return (
        <>
            <svg width="310" height="330">
                <g transform='translate(40, 20)'>
                    <image 
                    href={`${process.env.PUBLIC_URL}/image/ground_green.jpeg`} 
                    width={250} 
                    height={250} />
                    {calcData.map((item, idx) => (
                        item['x'] &&
                        <HitCourseModal 
                        gameRecordId={item['gameRecordId']} cx={item['x']} cy={item['y']} 
                        color={(colorType === 'hitResult') ? item['color'] : ballCodeColorHandler(item['ballCode'])}
                        key={item['gameRecordId']}
                        />
                    ))}
                </g>
                <g transform='translate(240, 230)'>
                    {hitResultObj.map((item, idx) => (
                    <g key={item['hitResultCode']}>
                    <circle cx={5} cy={15*idx} r={5} 
                    fill={chooseColorCode(item['hitResultCode'])}
                    key={"circle_"+item['hitResultCode']}
                    ></circle>
                    <text dy={15*idx+4} dx={15} fontSize="11px"
                    key={"text_"+item['hitResultCode']}
                    >
                        {t(item['hitResultEng'])}
                    </text>
                    </g>
                    ))}
                </g>
                <g transform='translate(40, 215)'>
                    {ballCodeArr.map((item, idx) => (
                    <g key={item['code']}>
                    <circle cx={5} cy={15*idx} r={5} 
                    fill={item['color']}
                    key={"circle_"+item['code']}
                    ></circle>
                    <text dy={15*idx+4} dx={15} fontSize="11px"
                    key={"text_"+item['code']}
                    >
                        {t(item['name'])}
                    </text>
                    </g>
                    ))}
                </g>
            </svg>
        </>
    )
}

export default HitCourseZoneChart;